module.exports = __webpack_public_path__ + "static/media/文件.5c96443f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/文件.jpg
// module id = 176
// module chunks = 2